import { ChevronFirst } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useSettings } from '@/providers/settings-provider';
import { Button } from '@/components/ui/button';

export function SidebarHeader() {
  const { settings, storeOption } = useSettings();

  const handleToggleClick = () => {
    storeOption(
      'layouts.admin.sidebarCollapse',
      !settings.layouts.admin.sidebarCollapse,
    );
  };

  return (
    <div className="sidebar-header hidden lg:flex items-center relative justify-between px-3 lg:px-6 shrink-0">
      <Link to="/" className="flex items-center gap-2 group">
        <img
          src="/tagna-logos/tagna-logo-only.png"
          alt="Tagna Logo"
          className="sidebar-logo h-8 w-8 shrink-0 object-contain transition-transform group-hover:scale-110"
        />
        <div className="sidebar-text flex flex-col leading-tight shrink-0">
          <h1 className="text-lg text-gray-900 dark:text-white tagna-brand-title transition-colors group-hover:text-primary-600 dark:group-hover:text-primary-400">
            TAGNA
          </h1>
          <p className="text-[7px] text-gray-600 dark:text-gray-400 tagna-brand-tagline whitespace-nowrap">
            Conquer Your Dream
          </p>
        </div>
      </Link>
      <Button
        onClick={handleToggleClick}
        size="sm"
        mode="icon"
        variant="outline"
        className={cn(
          'size-7 absolute start-full top-2/4 rtl:translate-x-2/4 -translate-x-2/4 -translate-y-2/4',
          settings.layouts.admin.sidebarCollapse
            ? 'ltr:rotate-180'
            : 'rtl:rotate-180',
        )}
      >
        <ChevronFirst className="size-4!" />
      </Button>
    </div>
  );
}
